module.exports = __webpack_public_path__ + "img/ihai.d0a1b28e.png";